"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var Loading = function Loading() {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "container loading",
      style: {
        width: 'auto'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "row"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "col-md-12 text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement(_Spinner["default"], null))))
  );
};

var _default = Loading;
exports["default"] = _default;